import { render, staticRenderFns } from "./BusinessExpiredGuard.vue?vue&type=template&id=14df8ac4&scoped=true"
import script from "./BusinessExpiredGuard.vue?vue&type=script&lang=js"
export * from "./BusinessExpiredGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14df8ac4",
  null
  
)

export default component.exports